import { API } from 'aws-amplify';
import { DeviceEventReviewSubmission } from '../model/reviewed-device-event/reviewed-device-event';

export const submitDeviceEventReview = async (data: DeviceEventReviewSubmission): Promise<void> =>
  await API.post('events', `/events/reviews`, { body: data });
